function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVwxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 180,
    height: 45,
    viewBox: "15 75 180 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,205.32133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(18.845,84.9073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1.759 L 6.067,-9.359 10.325,0 h 1.769 L 6.219,-12.84 H 5.912 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 33.207,84.907 h 1.651 V 72.068 h -1.651 z m 0.82,5.287 c 0.363,0.005 0.712,-0.14 0.964,-0.401 0.26,-0.254 0.405,-0.603 0.399,-0.968 0.004,-0.36 -0.14,-0.706 -0.399,-0.956 -0.252,-0.262 -0.601,-0.407 -0.964,-0.401 -0.359,-0.004 -0.704,0.141 -0.952,0.401 -0.259,0.25 -0.403,0.596 -0.399,0.956 -0.006,0.365 0.138,0.714 0.399,0.968 0.248,0.259 0.593,0.405 0.952,0.401",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(37.6673,84.9073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1.687 V -1.876 C 2.105,-1.226 2.646,-0.662 3.28,-0.22 3.795,0.134 4.403,0.324 5.027,0.33 5.544,0.312 6.048,0.16 6.49,-0.108 L 5.629,-1.501 C 5.355,-1.369 5.059,-1.293 4.756,-1.277 4.158,-1.295 3.589,-1.536 3.16,-1.953 2.578,-2.529 2.172,-3.261 1.992,-4.06 1.787,-4.791 1.686,-6.271 1.686,-8.496 v -4.344 h -1.688 z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(47.0013,89.6749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 1.652 v -4.769 h 2.62 V -6.195 H 1.652 V -17.607 H 0 v 11.412 h -2.254 v 1.426 H 0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(53.5393,84.9073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1.652 V -5.995 C 1.61,-7.009 1.69,-8.022 1.888,-9.017 c 0.218,-0.76 0.697,-1.421 1.353,-1.863 0.705,-0.469 1.536,-0.707 2.382,-0.685 0.832,-0.027 1.651,0.207 2.346,0.667 0.624,0.421 1.091,1.038 1.329,1.752 0.217,1.036 0.3,2.094 0.248,3.152 V 0 h 1.688 v -6.302 c 0,-1.77 -0.207,-3.103 -0.62,-4.001 -0.394,-0.875 -1.044,-1.609 -1.865,-2.106 -0.949,-0.537 -2.03,-0.801 -3.121,-0.761 -1.095,-0.039 -2.179,0.224 -3.133,0.761 -0.83,0.498 -1.485,1.24 -1.877,2.125 -0.413,0.909 -0.619,2.275 -0.619,4.099 z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(67.178,84.9073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 3.154 L 5.735,-7.304 8.512,0 h 1.929 L 13.168,-7.223 15.753,0 h 3.176 L 14.244,-12.84 H 12.202 L 9.464,-5.523 6.645,-12.84 H 4.626 Z",
    style: {
      fill: "#7a3691",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(94.013,82.2042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.943,0.024 -1.854,-0.355 -2.5,-1.044 -0.677,-0.722 -1.036,-1.684 -1.001,-2.673 -0.044,-1 0.312,-1.975 0.987,-2.714 0.647,-0.687 1.556,-1.065 2.5,-1.038 0.951,-0.024 1.867,0.358 2.519,1.05 0.681,0.732 1.043,1.703 1.005,2.702 C 3.551,-2.726 3.195,-1.76 2.522,-1.031 1.866,-0.346 0.949,0.029 0,-0.002 Z M -0.053,3.033 C 1.146,3.036 2.325,2.724 3.363,2.124 4.404,1.545 5.268,0.691 5.859,-0.342 6.452,-1.362 6.763,-2.523 6.757,-3.704 6.762,-4.897 6.45,-6.07 5.854,-7.104 5.273,-8.136 4.424,-8.99 3.394,-9.575 c -1.045,-0.597 -2.231,-0.904 -3.435,-0.892 -1.775,-0.026 -3.482,0.686 -4.715,1.965 -1.278,1.255 -1.984,2.981 -1.952,4.772 -0.04,1.916 0.768,3.751 2.207,5.014 1.204,1.132 2.797,1.758 4.448,1.749",
    style: {
      fill: "#9f4498",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(102.6438,84.9073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 2.762 V -1.616 C 3.017,-1.032 3.43,-0.529 3.954,-0.165 4.434,0.16 5.001,0.333 5.582,0.33 6.038,0.319 6.485,0.207 6.892,0 L 5.889,-2.776 C 5.603,-2.613 5.284,-2.518 4.957,-2.492 4.396,-2.535 3.91,-2.893 3.7,-3.413 3.357,-4.026 3.187,-5.23 3.186,-7.024 L 3.198,-7.65 v -5.193 H 0 Z",
    style: {
      fill: "#707bbc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(111.1536,89.8634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 3.222 v -10.25 l 4.744,5.293 h 4.046 l -5.532,-6.152 6.193,-6.687 H 8.676 l -5.454,5.918 v -5.918 H 0 Z",
    style: {
      fill: "#0eb6e1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(133.0091,83.1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.996,-1.996 c -0.813,0.803 -1.547,1.203 -2.207,1.203 -0.301,0.019 -0.6,-0.062 -0.851,-0.229 -0.19,-0.128 -0.305,-0.343 -0.306,-0.574 0.002,-0.177 0.072,-0.347 0.195,-0.476 0.287,-0.248 0.611,-0.449 0.962,-0.597 l 1.18,-0.59 c 0.987,-0.42 1.863,-1.061 2.561,-1.877 0.469,-0.652 0.713,-1.439 0.695,-2.242 0.023,-1.09 -0.436,-2.135 -1.255,-2.855 -0.936,-0.798 -2.142,-1.207 -3.371,-1.145 -1.764,-0.053 -3.442,0.769 -4.483,2.195 l 1.982,2.16 c 0.372,-0.437 0.823,-0.798 1.328,-1.069 0.411,-0.243 0.874,-0.383 1.351,-0.407 0.366,-0.018 0.73,0.092 1.027,0.308 0.236,0.16 0.379,0.422 0.389,0.708 0,0.495 -0.469,0.978 -1.404,1.451 l -1.084,0.545 c -2.077,1.046 -3.116,2.355 -3.116,3.929 -0.008,0.997 0.421,1.949 1.174,2.602 0.824,0.735 1.901,1.122 3.003,1.079 0.818,0.004 1.623,-0.184 2.355,-0.548 C -1.131,1.206 -0.49,0.666 0,0",
    style: {
      fill: "#44cfc5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(135.3167,89.8829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -0.404 H -0.798 V -2.649 H -1.29 v 2.245 H -2.091 V 0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(137.0169,88.211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.019,-0.043 0.035,-0.085 0.052,-0.128 0.017,0.045 0.036,0.088 0.054,0.131 0.019,0.043 0.037,0.083 0.059,0.12 L 0.95,1.59 C 0.957,1.606 0.967,1.621 0.979,1.635 0.989,1.645 1,1.653 1.014,1.658 1.028,1.663 1.042,1.667 1.057,1.668 H 1.114 1.486 V -0.981 H 1.052 V 0.73 0.834 c 0,0.038 0.004,0.076 0.009,0.115 L 0.26,-0.552 C 0.242,-0.585 0.218,-0.612 0.187,-0.632 0.156,-0.651 0.121,-0.661 0.085,-0.66 H 0.018 c -0.037,-0.001 -0.073,0.009 -0.104,0.028 -0.029,0.02 -0.054,0.047 -0.071,0.08 l -0.811,1.508 c 0.005,-0.041 0.008,-0.08 0.01,-0.121 0.002,-0.039 0,-0.073 0,-0.106 v -1.711 h -0.434 v 2.649 h 0.371 0.057 C -0.949,1.665 -0.935,1.662 -0.921,1.656 -0.907,1.65 -0.895,1.644 -0.885,1.632 -0.872,1.62 -0.861,1.604 -0.854,1.588 L -0.062,0.117 C -0.036,0.084 -0.017,0.043 0,0",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(62.2395,68.0401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.29,0 -0.533,-0.103 -0.731,-0.31 -0.199,-0.206 -0.297,-0.462 -0.297,-0.77 0,-0.201 0.044,-0.383 0.132,-0.544 0.088,-0.16 0.214,-0.288 0.379,-0.383 0.165,-0.094 0.339,-0.141 0.522,-0.141 0.18,0 0.349,0.047 0.507,0.143 0.159,0.095 0.285,0.228 0.379,0.399 0.093,0.17 0.14,0.349 0.14,0.536 0,0.188 -0.047,0.367 -0.139,0.537 -0.093,0.169 -0.219,0.3 -0.376,0.393 C 0.358,-0.046 0.187,0 0,0 m -1.34,0.262 h 0.335 v -0.489 c 0.133,0.186 0.284,0.325 0.457,0.418 0.172,0.092 0.363,0.139 0.575,0.139 0.37,0 0.687,-0.136 0.95,-0.408 0.262,-0.272 0.394,-0.599 0.394,-0.981 0,-0.39 -0.13,-0.722 -0.391,-0.995 -0.26,-0.272 -0.575,-0.409 -0.943,-0.409 -0.207,0 -0.397,0.044 -0.571,0.132 -0.174,0.088 -0.33,0.219 -0.471,0.394 V -3.366 H -1.34 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(65.469,68.0362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.278,0 -0.519,-0.105 -0.718,-0.315 -0.2,-0.21 -0.301,-0.464 -0.301,-0.762 0,-0.193 0.046,-0.371 0.137,-0.537 0.092,-0.166 0.215,-0.294 0.37,-0.385 0.156,-0.09 0.326,-0.136 0.512,-0.136 0.186,0 0.355,0.046 0.511,0.136 0.155,0.091 0.279,0.219 0.37,0.385 0.091,0.166 0.137,0.344 0.137,0.537 0,0.298 -0.101,0.552 -0.301,0.762 C 0.516,-0.105 0.276,0 0,0 m 0.001,0.334 c 0.401,0 0.733,-0.148 0.997,-0.444 0.239,-0.271 0.359,-0.59 0.359,-0.96 0,-0.371 -0.127,-0.696 -0.379,-0.973 -0.253,-0.277 -0.58,-0.416 -0.977,-0.416 -0.399,0 -0.726,0.139 -0.98,0.416 -0.252,0.277 -0.379,0.602 -0.379,0.973 0,0.368 0.12,0.687 0.36,0.957 0.263,0.299 0.597,0.447 0.999,0.447",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(67.094,68.3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.345 L 1.143,-1.929 1.973,0 H 2.034 L 2.87,-1.929 3.684,0 H 4.031 L 2.9,-2.656 H 2.839 L 2.006,-0.754 1.175,-2.656 H 1.112 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    transform: "translate(73.7093,67.2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.044,0.183 -0.109,0.328 -0.195,0.437 -0.28,0.546 -0.394,0.634 -0.534,0.7 -0.675,0.768 -0.822,0.801 -0.977,0.801 -1.232,0.801 -1.452,0.717 -1.636,0.55 -1.77,0.427 -1.871,0.244 -1.94,0 Z m 0,-0.716 0.282,-0.15 C 0.19,-1.052 0.083,-1.202 -0.038,-1.315 -0.159,-1.43 -0.296,-1.517 -0.447,-1.576 -0.6,-1.636 -0.771,-1.665 -0.963,-1.665 c -0.425,0 -0.757,0.142 -0.996,0.426 -0.239,0.284 -0.359,0.605 -0.359,0.963 0,0.338 0.101,0.637 0.304,0.901 0.257,0.335 0.601,0.503 1.033,0.503 0.443,0 0.797,-0.172 1.062,-0.516 C 0.27,0.37 0.365,0.067 0.369,-0.296 h -2.343 c 0.007,-0.308 0.104,-0.56 0.29,-0.758 0.187,-0.197 0.418,-0.297 0.693,-0.297 0.133,0 0.262,0.025 0.387,0.072 0.125,0.047 0.232,0.109 0.319,0.186 0.088,0.078 0.183,0.204 0.285,0.377",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(74.5755,68.3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 0.343 v -0.389 c 0.101,0.154 0.209,0.268 0.322,0.344 0.113,0.075 0.231,0.113 0.355,0.113 0.092,0 0.191,-0.03 0.296,-0.089 l -0.174,-0.29 c -0.071,0.032 -0.129,0.047 -0.177,0.047 -0.112,0 -0.22,-0.047 -0.323,-0.14 C 0.538,-0.498 0.459,-0.643 0.404,-0.84 0.363,-0.991 0.343,-1.297 0.343,-1.758 V -2.656 H 0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(78.3479,67.2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.044,0.183 -0.109,0.328 -0.195,0.437 -0.28,0.546 -0.394,0.634 -0.534,0.7 -0.675,0.768 -0.822,0.801 -0.977,0.801 -1.232,0.801 -1.452,0.717 -1.636,0.55 -1.77,0.427 -1.871,0.244 -1.94,0 Z m 0,-0.716 0.282,-0.15 C 0.19,-1.052 0.083,-1.202 -0.038,-1.315 -0.159,-1.43 -0.296,-1.517 -0.447,-1.576 -0.6,-1.636 -0.771,-1.665 -0.963,-1.665 c -0.425,0 -0.757,0.142 -0.996,0.426 -0.239,0.284 -0.359,0.605 -0.359,0.963 0,0.338 0.101,0.637 0.304,0.901 0.257,0.335 0.601,0.503 1.033,0.503 0.443,0 0.797,-0.172 1.062,-0.516 C 0.27,0.37 0.365,0.067 0.369,-0.296 h -2.343 c 0.007,-0.308 0.104,-0.56 0.29,-0.758 0.187,-0.197 0.418,-0.297 0.693,-0.297 0.133,0 0.262,0.025 0.387,0.072 0.125,0.047 0.232,0.109 0.319,0.186 0.088,0.078 0.183,0.204 0.285,0.377",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(80.6009,68.0401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.187,0 -0.358,-0.046 -0.516,-0.14 -0.158,-0.093 -0.283,-0.224 -0.377,-0.393 -0.092,-0.17 -0.139,-0.349 -0.139,-0.537 0,-0.187 0.047,-0.366 0.14,-0.536 0.095,-0.171 0.221,-0.304 0.379,-0.399 0.159,-0.096 0.329,-0.143 0.511,-0.143 0.183,0 0.356,0.047 0.521,0.141 0.164,0.095 0.29,0.223 0.378,0.383 0.089,0.161 0.133,0.343 0.133,0.544 0,0.308 -0.099,0.564 -0.298,0.77 C 0.534,-0.103 0.29,0 0,0 m 1.339,1.287 v -3.682 h -0.33 v 0.458 C 0.868,-2.112 0.711,-2.243 0.536,-2.331 0.361,-2.419 0.17,-2.463 -0.037,-2.463 c -0.368,0 -0.683,0.137 -0.943,0.409 -0.261,0.273 -0.392,0.605 -0.392,0.995 0,0.382 0.132,0.709 0.394,0.981 0.264,0.272 0.581,0.408 0.951,0.408 0.214,0 0.407,-0.047 0.58,-0.139 0.173,-0.093 0.325,-0.232 0.456,-0.418 v 1.514 z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92",
    transform: "translate(85.4163,65.9073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.187,0 0.358,0.046 0.516,0.14 0.158,0.093 0.283,0.225 0.376,0.394 0.093,0.169 0.139,0.349 0.139,0.537 0,0.189 -0.047,0.368 -0.14,0.54 C 0.797,1.781 0.671,1.915 0.513,2.01 0.354,2.105 0.185,2.152 0.005,2.152 -0.178,2.152 -0.352,2.105 -0.517,2.01 -0.682,1.915 -0.808,1.787 -0.896,1.625 -0.984,1.465 -1.028,1.283 -1.028,1.081 -1.028,0.773 -0.93,0.517 -0.731,0.31 -0.533,0.103 -0.289,0 0,0 M -1.34,-0.262 V 3.42 h 0.335 V 1.937 c 0.141,0.176 0.298,0.308 0.471,0.395 C -0.36,2.419 -0.17,2.463 0.037,2.463 0.405,2.463 0.72,2.326 0.98,2.054 1.241,1.781 1.371,1.45 1.371,1.062 1.371,0.678 1.239,0.35 0.977,0.078 0.714,-0.194 0.397,-0.33 0.028,-0.33 c -0.212,0 -0.404,0.047 -0.576,0.139 -0.173,0.093 -0.324,0.232 -0.457,0.418 v -0.489 z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    transform: "translate(87.1184,68.3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.354 L 1.248,-2.046 2.117,0 H 2.474 L 0.921,-3.628 H 0.567 l 0.501,1.173 z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100",
    transform: "translate(92.6897,68.0108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.215,-0.227 c -0.18,0.178 -0.354,0.266 -0.525,0.266 -0.109,0 -0.202,-0.036 -0.28,-0.109 -0.078,-0.074 -0.116,-0.159 -0.116,-0.256 0,-0.087 0.032,-0.169 0.096,-0.247 0.063,-0.08 0.198,-0.173 0.402,-0.281 0.25,-0.132 0.419,-0.259 0.509,-0.38 0.088,-0.124 0.132,-0.264 0.132,-0.418 0,-0.218 -0.075,-0.403 -0.226,-0.555 -0.15,-0.15 -0.338,-0.227 -0.562,-0.227 -0.151,0 -0.294,0.034 -0.431,0.1 -0.137,0.067 -0.25,0.159 -0.339,0.276 l 0.21,0.245 c 0.172,-0.198 0.353,-0.296 0.545,-0.296 0.134,0 0.248,0.045 0.343,0.132 0.095,0.088 0.142,0.191 0.142,0.31 0,0.098 -0.032,0.185 -0.094,0.261 -0.063,0.075 -0.203,0.17 -0.422,0.283 -0.235,0.124 -0.395,0.246 -0.48,0.367 -0.085,0.12 -0.126,0.258 -0.126,0.412 0,0.202 0.067,0.369 0.202,0.503 0.135,0.134 0.305,0.2 0.511,0.2 C -0.483,0.359 -0.242,0.24 0,0",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(95.8098,67.7501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.266,-0.169 c -0.228,0.312 -0.542,0.467 -0.938,0.467 -0.317,0 -0.581,-0.105 -0.79,-0.313 -0.21,-0.208 -0.315,-0.461 -0.315,-0.757 0,-0.194 0.048,-0.376 0.145,-0.547 0.097,-0.17 0.228,-0.303 0.396,-0.398 0.169,-0.094 0.357,-0.141 0.566,-0.141 0.383,0 0.694,0.156 0.936,0.466 L 0,-1.569 c -0.124,-0.192 -0.291,-0.34 -0.501,-0.446 -0.21,-0.105 -0.448,-0.158 -0.717,-0.158 -0.411,0 -0.753,0.134 -1.023,0.401 -0.272,0.266 -0.407,0.591 -0.407,0.974 0,0.257 0.063,0.495 0.19,0.716 0.127,0.221 0.301,0.393 0.522,0.517 0.222,0.124 0.47,0.185 0.745,0.185 0.172,0 0.338,-0.027 0.499,-0.08 0.16,-0.055 0.296,-0.124 0.408,-0.211 C -0.173,0.243 -0.078,0.134 0,0",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "translate(96.3264,68.3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 0.343 v -0.389 c 0.101,0.154 0.209,0.268 0.322,0.344 0.113,0.075 0.231,0.113 0.355,0.113 0.092,0 0.191,-0.03 0.296,-0.089 l -0.174,-0.29 c -0.071,0.032 -0.129,0.047 -0.177,0.047 -0.112,0 -0.22,-0.047 -0.323,-0.14 C 0.538,-0.498 0.459,-0.643 0.404,-0.84 0.363,-0.991 0.343,-1.297 0.343,-1.758 V -2.656 H 0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g112",
    transform: "translate(100.0989,67.2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.044,0.183 -0.109,0.328 -0.195,0.437 -0.28,0.546 -0.394,0.634 -0.534,0.7 -0.675,0.768 -0.822,0.801 -0.977,0.801 -1.232,0.801 -1.452,0.717 -1.636,0.55 -1.77,0.427 -1.871,0.244 -1.94,0 Z m 0,-0.716 0.282,-0.15 C 0.19,-1.052 0.083,-1.202 -0.038,-1.315 -0.159,-1.43 -0.296,-1.517 -0.447,-1.576 -0.6,-1.636 -0.771,-1.665 -0.963,-1.665 c -0.425,0 -0.757,0.142 -0.996,0.426 -0.239,0.284 -0.359,0.605 -0.359,0.963 0,0.338 0.101,0.637 0.304,0.901 0.257,0.335 0.601,0.503 1.033,0.503 0.443,0 0.797,-0.172 1.062,-0.516 C 0.27,0.37 0.365,0.067 0.369,-0.296 h -2.343 c 0.007,-0.308 0.104,-0.56 0.29,-0.758 0.187,-0.197 0.418,-0.297 0.693,-0.297 0.133,0 0.262,0.025 0.387,0.072 0.125,0.047 0.232,0.109 0.319,0.186 0.088,0.078 0.183,0.204 0.285,0.377",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g116",
    transform: "translate(103.2835,67.2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.044,0.183 -0.109,0.328 -0.195,0.437 -0.28,0.546 -0.394,0.634 -0.534,0.7 -0.675,0.768 -0.822,0.801 -0.977,0.801 -1.232,0.801 -1.452,0.717 -1.636,0.55 -1.77,0.427 -1.871,0.244 -1.94,0 Z m 0,-0.716 0.282,-0.15 C 0.19,-1.052 0.083,-1.202 -0.038,-1.315 -0.159,-1.43 -0.296,-1.517 -0.447,-1.576 -0.6,-1.636 -0.771,-1.665 -0.963,-1.665 c -0.425,0 -0.757,0.142 -0.996,0.426 -0.239,0.284 -0.359,0.605 -0.359,0.963 0,0.338 0.101,0.637 0.304,0.901 0.257,0.335 0.601,0.503 1.033,0.503 0.443,0 0.797,-0.172 1.062,-0.516 C 0.27,0.37 0.365,0.067 0.369,-0.296 h -2.343 c 0.007,-0.308 0.104,-0.56 0.29,-0.758 0.187,-0.197 0.418,-0.297 0.693,-0.297 0.133,0 0.262,0.025 0.387,0.072 0.125,0.047 0.232,0.109 0.319,0.186 0.088,0.078 0.183,0.204 0.285,0.377",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(104.2766,68.3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 0.335 v -0.477 c 0.134,0.183 0.282,0.32 0.445,0.41 0.162,0.09 0.34,0.135 0.532,0.135 0.194,0 0.367,-0.05 0.517,-0.151 C 1.98,-0.184 2.091,-0.32 2.163,-0.49 2.234,-0.662 2.271,-0.928 2.271,-1.289 V -2.656 H 1.936 v 1.267 c 0,0.306 -0.012,0.51 -0.038,0.613 C 1.859,-0.601 1.785,-0.469 1.675,-0.38 1.565,-0.291 1.422,-0.246 1.244,-0.246 1.042,-0.246 0.86,-0.314 0.7,-0.451 0.54,-0.588 0.434,-0.758 0.383,-0.959 0.352,-1.092 0.335,-1.332 0.335,-1.682 V -2.656 H 0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g124",
    transform: "translate(110.8128,67.2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.044,0.183 -0.109,0.328 -0.195,0.437 -0.28,0.546 -0.394,0.634 -0.534,0.7 -0.675,0.768 -0.822,0.801 -0.977,0.801 -1.232,0.801 -1.452,0.717 -1.636,0.55 -1.77,0.427 -1.871,0.244 -1.94,0 Z m 0,-0.716 0.282,-0.15 C 0.19,-1.052 0.083,-1.202 -0.038,-1.315 -0.159,-1.43 -0.296,-1.517 -0.447,-1.576 -0.6,-1.636 -0.771,-1.665 -0.963,-1.665 c -0.425,0 -0.757,0.142 -0.996,0.426 -0.239,0.284 -0.359,0.605 -0.359,0.963 0,0.338 0.101,0.637 0.304,0.901 0.257,0.335 0.601,0.503 1.033,0.503 0.443,0 0.797,-0.172 1.062,-0.516 C 0.27,0.37 0.365,0.067 0.369,-0.296 h -2.343 c 0.007,-0.308 0.104,-0.56 0.29,-0.758 0.187,-0.197 0.418,-0.297 0.693,-0.297 0.133,0 0.262,0.025 0.387,0.072 0.125,0.047 0.232,0.109 0.319,0.186 0.088,0.078 0.183,0.204 0.285,0.377",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g128",
    transform: "translate(111.8059,68.3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 0.335 v -0.477 c 0.134,0.183 0.282,0.32 0.445,0.41 0.162,0.09 0.34,0.135 0.532,0.135 0.194,0 0.367,-0.05 0.517,-0.151 C 1.98,-0.184 2.091,-0.32 2.163,-0.49 2.234,-0.662 2.271,-0.928 2.271,-1.289 V -2.656 H 1.936 v 1.267 c 0,0.306 -0.012,0.51 -0.038,0.613 C 1.859,-0.601 1.785,-0.469 1.675,-0.38 1.565,-0.291 1.422,-0.246 1.244,-0.246 1.042,-0.246 0.86,-0.314 0.7,-0.451 0.54,-0.588 0.434,-0.758 0.383,-0.959 0.352,-1.092 0.335,-1.332 0.335,-1.682 V -2.656 H 0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g132",
    transform: "translate(116.0501,68.0401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.189,0 -0.365,-0.046 -0.528,-0.14 -0.163,-0.093 -0.29,-0.223 -0.383,-0.388 -0.093,-0.165 -0.139,-0.344 -0.139,-0.536 0,-0.291 0.096,-0.532 0.287,-0.723 0.192,-0.19 0.44,-0.285 0.744,-0.285 0.308,0 0.556,0.094 0.744,0.283 0.186,0.188 0.28,0.437 0.28,0.744 0,0.201 -0.043,0.379 -0.129,0.536 C 0.79,-0.352 0.668,-0.228 0.51,-0.137 0.353,-0.045 0.183,0 0,0 M 0.988,0.262 H 1.323 V -1.855 C 1.323,-2.228 1.292,-2.5 1.228,-2.673 1.14,-2.917 0.987,-3.105 0.771,-3.236 0.554,-3.369 0.293,-3.435 -0.012,-3.435 c -0.222,0 -0.424,0.033 -0.601,0.097 -0.178,0.065 -0.323,0.151 -0.435,0.26 -0.111,0.108 -0.214,0.267 -0.308,0.476 h 0.364 c 0.098,-0.175 0.226,-0.306 0.383,-0.39 0.156,-0.085 0.35,-0.127 0.582,-0.127 0.228,0 0.422,0.043 0.579,0.13 0.157,0.087 0.269,0.195 0.336,0.327 0.067,0.131 0.1,0.344 0.1,0.637 v 0.136 C 0.862,-2.052 0.708,-2.177 0.526,-2.264 0.345,-2.351 0.151,-2.395 -0.054,-2.395 c -0.239,0 -0.464,0.061 -0.675,0.182 -0.21,0.121 -0.374,0.285 -0.488,0.49 -0.115,0.205 -0.173,0.43 -0.173,0.676 0,0.246 0.06,0.475 0.18,0.688 0.12,0.212 0.285,0.38 0.497,0.504 0.211,0.124 0.435,0.185 0.669,0.185 0.195,0 0.377,-0.041 0.545,-0.123 0.169,-0.082 0.331,-0.218 0.487,-0.406 z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 118.041,68.302 h 0.335 v -2.656 h -0.335 z m 0.166,1.094 c 0.076,0 0.142,-0.028 0.196,-0.083 0.053,-0.056 0.081,-0.122 0.081,-0.201 0,-0.076 -0.028,-0.142 -0.081,-0.197 -0.054,-0.056 -0.12,-0.084 -0.196,-0.084 -0.074,0 -0.138,0.028 -0.193,0.084 -0.054,0.055 -0.081,0.121 -0.081,0.197 0,0.079 0.027,0.145 0.081,0.201 0.055,0.055 0.119,0.083 0.193,0.083",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g138",
    transform: "translate(119.0725,68.3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 0.335 v -0.477 c 0.134,0.183 0.282,0.32 0.445,0.41 0.162,0.09 0.34,0.135 0.532,0.135 0.194,0 0.367,-0.05 0.517,-0.151 C 1.98,-0.184 2.091,-0.32 2.163,-0.49 2.234,-0.662 2.271,-0.928 2.271,-1.289 V -2.656 H 1.936 v 1.267 c 0,0.306 -0.012,0.51 -0.038,0.613 C 1.859,-0.601 1.785,-0.469 1.675,-0.38 1.565,-0.291 1.422,-0.246 1.244,-0.246 1.042,-0.246 0.86,-0.314 0.7,-0.451 0.54,-0.588 0.434,-0.758 0.383,-0.959 0.352,-1.092 0.335,-1.332 0.335,-1.682 V -2.656 H 0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "translate(124.2522,67.2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.044,0.183 -0.109,0.328 -0.195,0.437 -0.28,0.546 -0.394,0.634 -0.534,0.7 -0.675,0.768 -0.822,0.801 -0.977,0.801 -1.232,0.801 -1.452,0.717 -1.636,0.55 -1.77,0.427 -1.871,0.244 -1.94,0 Z m 0,-0.716 0.282,-0.15 C 0.19,-1.052 0.083,-1.202 -0.038,-1.315 -0.159,-1.43 -0.296,-1.517 -0.447,-1.576 -0.6,-1.636 -0.771,-1.665 -0.963,-1.665 c -0.425,0 -0.757,0.142 -0.996,0.426 -0.239,0.284 -0.359,0.605 -0.359,0.963 0,0.338 0.101,0.637 0.304,0.901 0.257,0.335 0.601,0.503 1.033,0.503 0.443,0 0.797,-0.172 1.062,-0.516 C 0.27,0.37 0.365,0.067 0.369,-0.296 h -2.343 c 0.007,-0.308 0.104,-0.56 0.29,-0.758 0.187,-0.197 0.418,-0.297 0.693,-0.297 0.133,0 0.262,0.025 0.387,0.072 0.125,0.047 0.232,0.109 0.319,0.186 0.088,0.078 0.183,0.204 0.285,0.377",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g146",
    transform: "translate(126.8723,69.3272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -1.462,-4.17 H -1.828 L -0.368,0 Z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g150",
    transform: "translate(128.6419,68.0401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.187,0 -0.358,-0.046 -0.516,-0.14 -0.158,-0.093 -0.283,-0.224 -0.377,-0.393 -0.092,-0.17 -0.139,-0.349 -0.139,-0.537 0,-0.187 0.047,-0.366 0.14,-0.536 0.095,-0.171 0.221,-0.304 0.379,-0.399 0.159,-0.096 0.329,-0.143 0.511,-0.143 0.183,0 0.356,0.047 0.521,0.141 0.164,0.095 0.291,0.223 0.378,0.383 0.089,0.161 0.133,0.343 0.133,0.544 0,0.308 -0.099,0.564 -0.298,0.77 C 0.534,-0.103 0.29,0 0,0 m 1.339,0.262 v -2.657 h -0.33 v 0.458 C 0.868,-2.112 0.711,-2.243 0.536,-2.331 0.361,-2.419 0.171,-2.463 -0.037,-2.463 c -0.368,0 -0.683,0.137 -0.943,0.409 -0.261,0.273 -0.392,0.605 -0.392,0.995 0,0.382 0.132,0.709 0.394,0.981 0.264,0.272 0.581,0.408 0.951,0.408 0.214,0 0.407,-0.047 0.58,-0.139 0.173,-0.093 0.325,-0.232 0.456,-0.418 v 0.489 z",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g154",
    transform: "translate(132.0423,68.0108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.215,-0.227 c -0.18,0.178 -0.354,0.266 -0.525,0.266 -0.109,0 -0.202,-0.036 -0.28,-0.109 -0.078,-0.074 -0.116,-0.159 -0.116,-0.256 0,-0.087 0.032,-0.169 0.096,-0.247 0.063,-0.08 0.198,-0.173 0.402,-0.281 0.25,-0.132 0.419,-0.259 0.509,-0.38 0.088,-0.124 0.132,-0.264 0.132,-0.418 0,-0.218 -0.075,-0.403 -0.226,-0.555 -0.15,-0.15 -0.338,-0.227 -0.562,-0.227 -0.151,0 -0.294,0.034 -0.431,0.1 -0.137,0.067 -0.25,0.159 -0.339,0.276 l 0.21,0.245 c 0.172,-0.198 0.353,-0.296 0.545,-0.296 0.134,0 0.248,0.045 0.343,0.132 0.095,0.088 0.142,0.191 0.142,0.31 0,0.098 -0.032,0.185 -0.094,0.261 -0.063,0.075 -0.203,0.17 -0.422,0.283 -0.235,0.124 -0.395,0.246 -0.48,0.367 -0.085,0.12 -0.126,0.258 -0.126,0.412 0,0.202 0.067,0.369 0.202,0.503 0.135,0.134 0.305,0.2 0.511,0.2 C -0.483,0.359 -0.242,0.24 0,0",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 132.586,68.302 h 0.335 v -2.656 h -0.335 z m 0.166,1.094 c 0.076,0 0.142,-0.028 0.196,-0.083 0.053,-0.056 0.081,-0.122 0.081,-0.201 0,-0.076 -0.028,-0.142 -0.081,-0.197 -0.054,-0.056 -0.12,-0.084 -0.196,-0.084 -0.074,0 -0.138,0.028 -0.193,0.084 -0.054,0.055 -0.081,0.121 -0.081,0.197 0,0.079 0.027,0.145 0.081,0.201 0.055,0.055 0.119,0.083 0.193,0.083",
    style: {
      fill: "#8a8579",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVwxLogo);
export default __webpack_public_path__ + "static/media/vwx-logo.b4f541d61377e4b1c8f64cf04f51a002.svg";
export { ForwardRef as ReactComponent };